<template>
  <div id="listing-container" class="container">
    <div class="row">
      <div v-for="(item, i) in items" :key="i" class="col-12 col-md-6 col-lg-4 listing-item mb-4">
        <AssociationItem v-if="item.type === 'association'" :item="item"/>
        <ItemComponent v-else :item="item"/>
      </div>

      <p v-if="items.length < 1" class="alert alert-danger position-top-0 text-center fs-6" id="no-results">
        Aucun résultat trouvé pour votre recherche, veuillez réessayer
      </p>
    </div>
  </div>
</template>

<script>
import ItemComponent from "@/components/listing/Item.vue";
import AssociationItem from "@/components/listing/AssociationItem.vue";

const paginationListingLimit = 10;

export default {
  name: 'ListingView',
  components: {AssociationItem, ItemComponent},

  data() {
    return {
      listing: []
    }
  },

  props: {
    items: Array
  },

  mounted() {
    this.listing = this.paginateData(this.items);
    window.addEventListener('scroll', this.handleScroll)
  },

  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  watch: {
    items(newItems) {
      this.listing = this.paginateData(newItems);
    }
  },

  methods: {
    getNextListing(offset, limit) {
      const paginatedDatas = this.paginateData(this.items, offset, limit);
      this.listing.push(...paginatedDatas);
    },

    paginateData(datas, offset = 0, limit = paginationListingLimit) {
      return datas.slice(offset, offset + limit);
    },

    handleScroll() {
      if (this.$refs.listing.getBoundingClientRect().bottom < window.innerHeight) {
        this.getNextListing(this.listing.length, paginationListingLimit);
      }
    },
  }
}
</script>

<style scoped>
#listing-container {
  padding-top: 5px;
	margin: 0;
	max-width: 100%;
	overflow-y: auto;
	height: var(--height__sections-left-n-right);
}

.listing-item {
  animation: fadeIn ease 1s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (max-width: 1024px) {
  #listing-container {
    height: var(--height__sections-left-n-right-mobile);
  }
}
</style>